import { useNavigate } from 'react-router-dom';
import { PortalLayout } from '../components/layout/component';
import ErrorIcon from '../theme/styled-components/ErrorIcon';
import Button from '../ui/Button';
import { Title, Wrapper } from '../ui/Page';
import Panel from '../ui/Panel';
import Typography from '../ui/Typography';

function NotFound() {
  const navigate = useNavigate();

  const goback = () => {
    navigate(-1);
  };

  return (
    <PortalLayout appBar={false} automaticLogout={false}>
      <Wrapper>
        <Title>Page Not Found</Title>

        <Panel centre>
          <ErrorIcon height="45px" width="45px" fill="#F0645A" />

          <Typography>
            The page you are looking for can not be found.
          </Typography>

          <Button onClick={goback}>Go back to the previous page</Button>
        </Panel>
      </Wrapper>
    </PortalLayout>
  );
}

export default NotFound;
